export const ALLOWED_ROUTES_PROJECT_NOT_SET = [
    'asset.preview',
    'onboarding',
];
